<div [ngClass]="portalClass" class="school-public-portal-container">

    <h1 *ngIf="showNotFound">
        <i class="fad fa-user-lock fa-2x" style="--fa-secondary-color: red"></i> School Portal not found
    </h1>

    <div *ngIf="!showNotFound">
        <div class="dashboard-title">
            {{ flightSchoolOrganization?.FlightSchoolIdDisplay }} Checkride Manager
        </div>
        <dw-router-parent>
            <ng-template>

                <dw-message [(message)]="message"></dw-message>

                <button class="btn btn-primary" (click)="addStudent()">Create Checkride Request</button>              

            </ng-template>
        </dw-router-parent>
    </div>
</div>